<template>
  <section class="body">
    <div>
      <div class="modal-top-section modal-top-section--align-center">
        <h3 class="modal-top-section__title">Agrega usuarios</h3>
        <p class="modal-top-section__subtitle">
          Seleccione los usuarios de la campaña que deseas agregar a esta cola.
        </p>
      </div>
    </div>
    <section class="container">
      <!-- Vista seleccionar agentes -->
      <div class="section--agents">
        <p class="title-agents">Usuarios</p>
        <div class="box">
          <div class="container__search">
            <a-checkbox
              :checked="selectAllCheckbox"
              @change="handleSelectAllAgents"
              class="checkbox__select"
            >
              Seleccionar todos
            </a-checkbox>
            <a-input
              v-model:value="search"
              placeholder="Busca los usuarios aquí"
              class="search__agents"
            >
              <template #suffix>
                <SearchOutlined />
              </template>
            </a-input>
          </div>

          <div
            id="style-scroll-agente"
            class="scrollbar-agent"
            :class="agents?.length < 1 ? 'hideText' : ''"
          >
            <div class="container-items-agent">
              <div v-for="agent in listAgent" :key="agent.profile">
                <a-checkbox
                  v-if="agent.agents.length > 0"
                  class="entity"
                  :checked="isProfile(agent)"
                  @change="handleProfileSelected($event, agent)"
                >
                  <span>{{ agent.profile }}</span>
                </a-checkbox>
                <div v-if="agent.agents.length > 0" class="line-gray" />
                <div v-for="subAgent in agent.agents" :key="subAgent.id" class="item__agent">
                  <a-checkbox
                    class="flex"
                    :checked="isAgent(subAgent)"
                    @change="handleSelectedAgentItems($event, subAgent)"
                  >
                    <div>
                      <a-tooltip placement="top">
                        <template #title v-if="subAgent.fullname?.length > 21">
                          {{ subAgent.fullname }}
                        </template>
                        <p class="text__name">
                          {{ subAgent.fullname.toLowerCase() }}
                        </p>
                      </a-tooltip>
                    </div>
                  </a-checkbox>
                  <div v-if="subAgent?.picture">
                    <img class="user__icon" :src="subAgent?.picture" alt="perfil" />
                  </div>
                  <div
                    v-else
                    :class="subAgent.role.name === 'Agente' ? 'background__agent' : ''"
                    class="background__profile"
                  >
                    <img
                      v-if="subAgent.icon"
                      class="user__profile"
                      :class="subAgent.role.name === 'Agente' ? 'user__agente' : ''"
                      :src="getProfileImage(subAgent?.icon || iconDefault)"
                      alt="perfil"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text__left" v-if="agents?.length < 1">
            <p class="infoUser">
              Debes agregar usuarios a la campaña asociada para visualizarlos aquí.
            </p>
          </div>
        </div>
      </div>
      <!-- Vista agentes seleccionados -->
      <div class="section__selected">
        <p class="title-agents">Seleccionados</p>
        <div class="box">
          <CustomScrollbar v-if="selectedItems.length > 0" height="415px" width="100%">
            <div v-for="agent in listAgent" :key="agent.profile" class="style-container">
              <span v-if="isProfile(agent)" class="label">
                {{ agent.profile }}
              </span>
              <div v-if="isProfile(agent)" class="line-gray" />
              <div v-for="subAgents in agent.agents" :key="subAgents.id">
                <div v-if="isAgent(subAgents)" class="selection-agents">
                  {{
                    subAgents.fullname.length > 18
                      ? subAgents.fullname.toLowerCase().substring(0, 18) + "..."
                      : subAgents.fullname.toLowerCase()
                  }}
                  <div class="flex">
                    <div v-if="subAgents?.picture">
                      <img class="user__icon" :src="subAgents?.picture" alt="perfil" />
                    </div>
                    <div
                      v-else
                      :class="subAgents.role.name === 'Agente' ? 'background__agent' : ''"
                      class="background__profile"
                    >
                      <img
                        v-if="subAgents.icon"
                        class="user__profile"
                        :class="subAgents.role.name === 'Agente' ? 'user__agente' : ''"
                        :src="getProfileImage(subAgents?.icon || iconDefault)"
                        alt="perfil"
                      />
                    </div>
                    <a href="#" :parent-id="subAgents.id">
                      <CloseOutlined
                        class="icon--close"
                        @click.stop.prevent="removeSelectedItem(subAgents)"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </CustomScrollbar>
          <div class="container__information" v-if="selectedItems.length == 0">
            <img :src="squareImage" alt="square" />
            <p class="infoUser">Aquí se visualizará los usuarios que vaya seleccionando.</p>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import { SearchOutlined, CloseOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import { defineComponent, ref, computed, watch, createVNode } from "vue";
import { useStore } from "vuex";
import { Modal } from "ant-design-vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { fetchAgentsByQueue } from "@/app/supervision/services";
import squareImage from "@/app/entities/assets/square.svg?url";

export default defineComponent({
  components: {
    CloseOutlined,
    SearchOutlined,
    CustomScrollbar,
  },
  props: {
    isActive: {
      required: true,
      type: Boolean,
    },
    isEdit: {
      required: true,
      type: Boolean,
      default: false,
    },
    idPortfolio: {
      type: Number,
      default: null,
    },
    idQueue: {
      type: Number,
      default: null,
    }
  },
  setup(_, { emit }) {
    const store = useStore();
    const search = ref("");
    const select = ref("");
    const deleteUser = ref(false);
    const agentsState = computed(() => store.getters["getQueueState"].users);
    const copyAgentState = [...agentsState.value];
    const selectedItems = ref(agentsState.value);
    watch(
      () => [...selectedItems.value],
      () => {
        emit("onShowConfirmationModal");
      }
    );
    return {
      selectedItems,
      search,
      select,
      deleteUser,
      agentsState,
      copyAgentState,
      squareImage,
    };
  },
  computed: {
    portfolio() {
      return this.$store.getters["getQueueState"].portfolios;
    },
    agents() {
      let agents = this.$store.getters["getAgentQueue"];
      if (this.search != "") {
        agents = agents.filter((agent) => {
          return agent.fullname.toLowerCase().includes(this.search.toLowerCase());
        });
      }
      return agents;
    },
    listAgent() {
      const arr = [];
      this.profiles.forEach((profile) => {
        const agents = this.agents.filter((agent) => agent.profile_name === profile.name);
        arr.push({ profile: profile.name, agents });
      });

      return arr;
    },
    selectAllCheckbox() {
      return this.selectedItems.length === this.agents.length;
    },
    profiles() {
      // let listProfiles = this.$store.getters["getProfileList"];
      // console.log({ listProfiles, grouped: this.$store.getters["image.png"] });
      // if (!listProfiles.some((profile) => profile.name === "Owner")) {
      //   listProfiles.push({ name: "Owner", total_users: 1 });
      // }
      // return listProfiles.filter((item) => item.total_users > 0);
      return this.$store.getters["getAgentQueueProfile"];
    },
  },
  watch: {
    async idQueue() {
      const responseAgents = await fetchAgentsByQueue(this.idQueue);
      this.selectedItems = responseAgents.map((el) => el.id);
      console.log(responseAgents, 'response agents');
    }
  },
  async created() {
    this.$emit("disable", false);
    this.fetchAgentsByCampaign(this.idPortfolio ?? this.portfolio[0]);
    if (this.idQueue) {
      const responseAgents = await fetchAgentsByQueue(this.idQueue);
      this.selectedItems = responseAgents.map((el) => el.id);
      console.log(responseAgents, 'response agents');
    }
  },
  methods: {
    getProfileImage(profile) {
      return new URL(`../../../../../users/assets/profiles/${profile}`, import.meta.url).href;
    },
    async fetchAgentsByCampaign(id) {
      await this.$store.dispatch("fetchAgentsQueue", id);
    },
    handleSearch() {
      const search = this.listAgent.filter((agent) =>
        agent.agents.filter((item) => {
          return item.fullname.toLowerCase().includes(this.search.toLowerCase());
        })
      );
      console.log(search);
    },
    removeSelectedItem: function (item) {
      this.$root.$emit("send", item.id);
      const el = this.selectedItems.find((x) => x === item.id);
      const index = this.selectedItems.indexOf(el);
      this.selectedItems.splice(index, 1);
    },
    isProfile(agent) {
      let checkProfile = false;
      agent.agents.forEach((agnt) => {
        if (this.selectedItems.includes(agnt.id)) checkProfile = true;
      });
      return checkProfile;
    },
    isAgent(agent) {
      return this.selectedItems.includes(agent?.id);
    },
    handleSelectedAgentItems(e, agent) {
      const checked = e.target.checked;
      if (checked) {
        this.selectedItems.push(agent.id);
      } else {
        const index = this.selectedItems.findIndex((item) => {
          return item == agent.id;
        });
        this.selectedItems.splice(index, 1);
      }
    },
    handleSelectAllAgents(event) {
      if (event.target.checked) {
        console.log(this.listAgent, 'list agents');
        this.listAgent.forEach((item) => {
          item.agents.map((agent) => this.selectedItems.push(agent.id));
        });
      } else {
        this.selectedItems = [];
        this.$emit("onShowConfirmationModal");
      }
    },
    async handleOk(current) {
      let value = current;
      let removeAgents = false;
      await this.copyAgentState.forEach((agent) => {
        if (!this.selectedItems.includes(agent)) {
          removeAgents = true;
        }
      });
      if (removeAgents) {
        await this.removeAgentsUpdate();
        // this.$emit("remove-agents");
        this.$store.dispatch("setQueueProperties", { users: this.selectedItems });
      } else {
        this.$store.dispatch("setQueueProperties", { users: this.selectedItems });
        value = current + 1;
        return value;
      }
    },
    removeAgentsUpdate() {
      return new Promise((res) => {
        Modal.confirm({
          title: "¿Estás seguro de quitar usuarios de esta cola?",
          content:
            "Recuerda que estos usuarios ya no recibirán tickets de esta cola, y sus tickets serán reasignados en esta cola, a otros usuarios disponibles.",
          width: 450,
          icon: createVNode(QuestionCircleOutlined),
          onOk: () => {
            res();
            // this.$store.dispatch("setQueueProperties", { users: this.selectedItems });
            // this.$emit("updateQueue");
          },
          onCancel: () => this.$emit("keep-editing"),
          centered: true,
          okText: "Quitar",
          cancelText: "Cancelar",
        });
      });
    },
    handleReset() {
      this.selectedItems = [];
    },
    handleProfileSelected(e, agent) {
      const checked = e.target.checked;
      if (checked) {
        agent.agents.map((agnt) => {
          this.selectedItems.push(agnt.id);
        });
      } else {
        agent.agents.map((agnt) => {
          const index = this.selectedItems.findIndex((item) => {
            return item == agnt.id;
          });
          this.selectedItems.splice(index, 1);
        });
      }
    },
  },
});
</script>

<style lang="sass" scoped>
.container
  display: flex
  box-sizing: border-box
  border-radius: 2px
  justify-content: space-evenly
  .box
    background: $white
    border: 1px solid $gray-4
    box-sizing: border-box
    border-radius: 2px
    display: flex
    flex-direction: column
    height: 420px
  .container__information
    margin: 0 auto
    text-align: center
    margin-top: 80px
  .infoUser
    margin-top: 40px
    color: $gray-6

.container__search
  display: flex
  flex-direction: column
  margin-bottom: 10px

.item__agent
  display: flex
  justify-content: space-between
  align-items: center
  margin-left: 20px
  padding: 5px 0px

.title-agents
  margin-bottom: 0px
  font-weight: 600
  color: $gray-9

.selection-agents
  background: $blue-1
  border: 1px solid $blue-3
  box-sizing: border-box
  border-radius: 3px
  height: 35px
  display: flex
  padding: 1px 8px 1px
  margin: 2px 0px
  justify-content: space-between
  margin-left: 20px
  margin-top: 10px
  align-items: center
input[type="checkbox"]
  width: 16px
  height: 16px
  margin-right: 8px
input:checked
  background-color: $blue-6
  &:hover
    background-color: $blue-6

.scrollbar-agent
  float: left
  overflow-y: scroll
  padding-right: 10px
.label-agent
  padding-left: 5px

#style-scroll-agente::-webkit-scrollbar-track
  border-radius: 10px
  background-color: $white
#style-scroll-agente::-webkit-scrollbar
  width: 5px
  background-color:  $white
#style-scroll-agente::-webkit-scrollbar-thumb
  border-radius: 10px
  background-color: #C4C4C4

.section--agents
  margin-right: 12px
  width: 49%

.icon--close
  color: $gray-8
  padding-left: 10px

.section__selected
  width: 49%

.checkbox__select
  border-bottom: 1px solid #E8E8E8
  margin-bottom: 10px
  padding: 8px 12px

.search__agents
  margin-left: 7px
  width: 90%
.container-items-agent
  padding: 0 20px
  span:first-child
    font-size: 14px
    font-weight: 600
.line-gray
  border-bottom: 1px solid #E8E8E8

.image-without-modules
  display: block
  margin: 15% 33%
.label
  font-weight: 600
  font-size: $font-normal
  line-height: 25px
  color: $gray-9
  padding-bottom: 10px
.style-container
  padding: 5px 8px
.container__image
  margin-right: 10px

.user__icon
  width: 22px
  height: 22px
  margin: 6px
  border-radius: 50%

.user__profile
  width: 17px
  height: 17px
  margin: 6px
  filter: invert(62%) sepia(84%) saturate(1521%) hue-rotate(178deg) brightness(103%) contrast(99%)

.user__agente
  width: 17px
  height: 17px
  margin: 6px
  filter: invert(55%) sepia(46%) saturate(1606%) hue-rotate(351deg) brightness(105%) contrast(96%)

.background__profile
  background-color: rgb(230, 247, 255)
  border-radius: 50%
  display: flex
  align-items: center
  margin-right: 3px
  height: 32px

.background__agent
  background: #FFF6E2
  border-radius: 50%
  display: flex
  align-items: center
  margin-right: 3px
  height: 32px

.text__left
  margin-top: 86px
  text-align: center

.hideText
  display: none

.flex
  display: flex
  align-items: center

.text__name
  overflow: hidden
  white-space: nowrap
  text-overflow: ellipsis
  margin-right: 4px
  width: 150px
  margin-bottom: 0
</style>
